<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit fee details" onOk="handleOk">
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Fee</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form" @submit="handleEdit">
          <div class="row">
            <div class="col-md-12 mb-2">
              <a-form-item
                label="Select Class Fee"
              >
                <a-spin :spinning="feesLoading">
                  <a-select
                    v-decorator="[
                      'class_fee_id',
                      {rules: [{ required: true, message: 'Please select a class fee!!' }]}
                    ]"
                    placeholder="Select Class Fee"
                    :disabled="true"
                  >
                      <a-select-option v-for="classFee in classFees" :value="classFee.id" :key="classFee.id">
                        {{classFee.fee.name}}
                      </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-12 mb-2">
              <a-form-item class="mb-0" label="Fee Amount">
                <div style="width:180px;">
                  <a-input-number
                    placeholder="Fee Amount"
                    v-decorator="[`fee_amount`, {rules: [{ required: true, message: 'Please input fee amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                    :disabled="true"
                  />
                </div>
              </a-form-item>
            </div>
              <div class="col-md-4 mb-2">
                <a-form-item class="mb-0" label="Fine Amount">
                  <div style="width:120px;">
                    <a-input-number
                      placeholder="Fine"
                      v-decorator="[`fine_amount`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                      :initialValue="0"
                      :min="0"
                      :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                      style="width:100%;"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2">
                <a-form-item label="Discount Type">
                  <a-select style="width:150px" v-model="discountType">
                    <a-select-option value="amount">Amount</a-select-option>
                    <a-select-option value="percentage">Percentage</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2" v-if="discountType === 'amount'">
                <a-form-item class="mb-0" label="Discount Amount">
                  <div style="width:120px;">
                    <a-input-number
                      placeholder="Discount amount"
                      v-decorator="[`discount_amount`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                      :initialValue="0"
                      :min="0"
                      :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                      style="width:100%;"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2" v-if="discountType === 'percentage'">
                <a-form-item class="mb-0" label="Discount %">
                  <div style="width:120px;">
                    <a-input-number
                      placeholder="Discount %"
                      v-decorator="[`discount_percentage`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                      :initialValue="0"
                      :min="0"
                      :max="100"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                      style="width:100%;"
                    />
                  </div>
                </a-form-item>
              </div>
            <div class="col-md-4 mb-2">
              <a-form-item
                label="Start Date"
              >
              <a-date-picker
                v-decorator="[
                'start_date',
                {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
            <div class="col-md-4 mb-2" >
              <a-form-item
                label="Due Date"
              >
                <a-date-picker
                  v-decorator="[
                'due_date',
                ]"
                  :format=dateFormat />
              </a-form-item>
            </div>
            <div class="col-md-4 mb-2" >
              <a-form-item
                label="End Date"
              >
              <a-date-picker
                v-decorator="[
                'end_date',
                {rules: [{ required: true, message: 'Please input an end date' }], },
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EditGenerateFee',
  props: ['classId', 'sessionId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      feeSettingId: null,
      discountType: 'amount',
    }
  },
  mounted: function () {
    this.$eventBus.$on('openGenerateFeeSettingsEditModal', this.showModal)
  },
  created: function() {

  },
  methods: {
    moment,
    showModal: function(feeSetting) {
      this.feeSettingId = feeSetting.id
      this.visible = true
      this.spinning = true

      if (feeSetting.discount_percentage) {
        this.discountType = 'percentage'
      } else {
        this.discountType = 'amount'
      }
      // this.feesLoading = false
      // this.loading = true

      this.getClassFees(feeSetting)
    },
    getClassFees(feeSetting) {
      // this.feesLoading = true
      this.$http
        .get(`/api/class_fees`, {
          params: {
            session_id: this.sessionId,
            class_id: this.classId,
          },
        })
        .then(({ data }) => {
          this.spinning = false
          this.classFees = data.data

          const fieldsData = this.makeFeeSettingData(feeSetting)
          this.form.setFieldsValue(fieldsData)
        })
        .catch(error => {
          console.log(error)
          this.feesLoading = false
        })
    },
    handleEdit: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              const formData = this.makeGenerateEditFeeData(values)
              this.$http
                .patch('/api/fee_setting/' + this.feeSettingId, formData)
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: `Generated fee setting and student fees updated successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    makeFeeSettingData: function(data) {
      const fieldData = {
        class_fee_id: data.class_fee.id,
        start_date: moment(data.start_date),
        due_date: data.due_date ? moment(data.due_date) : null,
        end_date: moment(data.end_date),
        fee_amount: data.class_fee.fee_amount,
        fine_amount: data.fine_amount,
        discount_amount: data.discount_amount,
        discount_percentage: data.discount_percentage,
      }
      return fieldData
    },
    makeGenerateEditFeeData(values) {
      values.class_id = this.classId
      values.session_id = this.sessionId
      values.start_date = moment(values.start_date).format('YYYY-MM-DD')
      values.due_date = values.due_date ? moment(values.due_date).format('YYYY-MM-DD') : null
      values.end_date = moment(values.end_date).format('YYYY-MM-DD')

      delete values.class_fee_id
      delete values.fee_amount

      values.auto_generate = 0
      return values
    },
    handleFeeChange(feeId) {
      const fee = find(this.classFees, { id: feeId })
      if (fee) {
        this.form.setFieldsValue({ fee_amount: fee.fee_amount })
      } else {
        this.form.setFieldsValue({ fee_amount: 0 })
      }
    },
  },
}
</script>
